import React from 'react';
import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';

// Surfaces supply color, spacing and hover treatment.
const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: none;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--primary-brand);
    outline-offset: 2px;
    border-radius: var(--border-radius-radius-sm, 4px);
  }
`;

export interface CloseButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // Size of the close glyph in px (Material Symbols). Default 20.
  iconSize?: number;
  // Required: the glyph is icon-only (aria-hidden), so the button has no text to
  // name it. Describe what is being closed, e.g. "Close feedback".
  'aria-label': string;
}

// Defaults to type="button" so it never submits a surrounding form. `aria-label`
// is a required prop (the glyph is icon-only), so an unnamed close button can't
// ship. Forwards its ref and className so it composes cleanly under
// `styled(CloseButton)`.
export const CloseButton = React.forwardRef<
  HTMLButtonElement,
  CloseButtonProps
>(({ iconSize = 20, type = 'button', ...rest }, ref) => (
  <StyledButton ref={ref} type={type} {...rest}>
    <Icon name="close" size={iconSize} aria-hidden="true" />
  </StyledButton>
));

CloseButton.displayName = 'CloseButton';
